import React, { Component } from "react";

import { getFavoriteBook } from "./functions/books";

import "./ShowFavoriteBook.css";

import Book from "./Book";

class ShowFavoriteBook extends Component {
  render() {
    const book = getFavoriteBook();

    return (
      <div className="Callout Center FavoriteBook">
      <img className="ClearBook" src="/foreword/images/x.png" alt="Clear Book" onClick={this.props.clearBook} />
        <div className="Sending">You Are Sending</div>
        <Book book={book} />
      </div>
    );
  }
}

export default ShowFavoriteBook;
